<template>
  <div class="page-container cash-register-sessions">
    <portal to="page-name">Tesouraria</portal>
    <div class="card card-page" v-if="hasAccess">
      <div class="card-header">
        <h1 class="card-title">Tesouraria · caixas</h1>
      </div>
      <div class="card-body">
        <div class="columns">
          <div class="column col-4 col-md-12 form-group">
            <label class="form-label">Período de abertura</label>
            <st-date-period :start-date.sync="filter.startDate" :end-date.sync="filter.endDate"/>
          </div>
          <div class="column col-3 col-md-6 form-group">
            <label class="form-label">Status</label>
            <select class="form-select" v-model="filter.status">
              <option value="">Todos</option>
              <option value="open">Abertos</option>
              <option value="closed">Fechados</option>
            </select>
          </div>
          <div class="column col-3 col-md-6 form-group">
            <label class="form-label">Conferência</label>
            <select class="form-select" v-model="filter.reviewStatus">
              <option value="">Todos</option>
              <option value="pending">Aguardando</option>
              <option value="flagged">Com ressalva</option>
              <option value="ok">Conferidos</option>
            </select>
          </div>
          <div class="column col-2 col-md-12 form-group">
            <label class="form-label">&nbsp;</label>
            <button class="btn btn-primary btn-icon btn-icon-left btn-block" @click="load"
                    :class="{loading}" :disabled="loading">
              <fa-icon :icon="['fal', 'search']"/>Buscar
            </button>
          </div>
        </div>
        <div class="loading loading-lg" v-if="loading"></div>
        <div class="empty" v-else-if="items.length === 0">
          <div class="empty-icon"><fa-icon :icon="['fal', 'info-circle']" size="3x"/></div>
          <p class="empty-title h5">Nenhum caixa no período</p>
        </div>
        <table class="table table-striped table-hover" v-else>
          <thead>
          <tr>
            <th>Operador</th>
            <th>Abertura</th>
            <th>Situação</th>
            <th class="text-right">Recebido</th>
            <th class="text-right hide-sm">Sangrias</th>
            <th class="text-right">Diferença</th>
            <th>Conferência</th>
            <th style="width: 60px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.user.name }}</td>
            <td>{{ item.opening.date | date('datetime') }}</td>
            <td>
              <template v-if="item.status === 'closed'">
                <span class="label label-gray mr-1">Fechado</span>
                <small class="text-gray">{{ item.closing.date | date('datetime') }}</small>
              </template>
              <span class="label label-success" v-else>Aberto</span>
            </td>
            <td class="text-right">{{ netReceipts(item) | currency }}</td>
            <td class="text-right hide-sm">{{ item.totals.withdrawals | currency }}</td>
            <td class="text-right text-bold"
                :class="{'text-error': hasDifference(item)}">
              <template v-if="item.status === 'closed'">
                {{ item.closing.cashDifference | currency }}
              </template>
              <template v-else>-</template>
            </td>
            <td>
              <span class="label" :class="reviewClass(item)" v-if="item.status === 'closed'">
                {{ reviewLabel(item.review) }}
              </span>
            </td>
            <td class="text-right">
              <router-link :to="`/financial/cash-register-sessions/${item.id}`"
                           class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                           data-tooltip="Detalhes">
                <fa-icon :icon="['fal', 'eye']"/>
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <forbidden v-else></forbidden>
  </div>
</template>

<script>
import moment from 'moment';
import { LIST_CASHIERS } from '@/data/actions/modules/financial';
import { getReviewLabel, getReviewClass } from '@/data/cash-register-entry-types';
import Forbidden from '@/components/auth/Forbidden.vue';

export default {
  components: {
    Forbidden,
  },
  data() {
    return {
      loading: false,
      items: [],
      filter: {
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        status: '',
        reviewStatus: '',
      },
    };
  },
  computed: {
    hasAccess() {
      return this.$can(LIST_CASHIERS);
    },
  },
  mounted() {
    if (this.hasAccess) {
      this.applyQuery();
      this.load();
    }
  },
  methods: {
    applyQuery() {
      const query = this.$route.query || {};
      if (moment(query.startDate, 'YYYY-MM-DD', true).isValid()) {
        this.filter.startDate = String(query.startDate);
      }
      if (moment(query.endDate, 'YYYY-MM-DD', true).isValid()) {
        this.filter.endDate = String(query.endDate);
      }
    },
    reviewLabel: getReviewLabel,
    netReceipts(item) {
      const totals = item.totals || {};
      return typeof totals.netReceipts === 'number' ? totals.netReceipts : totals.receipts || 0;
    },
    hasDifference(item) {
      return item.status === 'closed' && item.closing.cashDifference !== 0;
    },
    reviewClass(item) {
      return getReviewClass(item.review);
    },
    load() {
      this.loading = true;
      const params = {
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        limit: 0,
      };
      if (this.filter.status) params.status = this.filter.status;
      if (this.filter.reviewStatus) params.reviewStatus = this.filter.reviewStatus;
      this.$http.get('/cash-register/sessions', { params })
        .then(({ data }) => {
          this.items = data.items;
        })
        .catch((e) => {
          this.$toast.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
